import { Alert } from '@/components/feedback/Alert'
import { useReportErrors } from '@/hooks/use-cube-meta'
import { messages } from '@/lib/messages'
import { useAuthStore } from '@/stores/auth-store'

/**
 * Bozuk meta'lı Cube view'ları menüden sessizce düşer; superadmin bunu burada görür.
 * Superadmin token'ı tüm izinleri taşıdığı için `/meta`'da her view vardır.
 */
export function ReportErrorsBanner() {
  const isSuperadmin = useAuthStore((state) => state.identity?.is_superadmin ?? false)
  const { data: errors } = useReportErrors(isSuperadmin)
  if (!isSuperadmin || !errors?.length) return null

  return (
    <Alert tone="danger" className="mb-4" title={messages.report.definitionErrors(errors.length)}>
      <ul className="space-y-1">
        {errors.map((error) => (
          <li key={error.view}>
            <span className="text-foreground font-mono font-medium">{error.view}</span>
            <pre className="mt-0.5 text-xs whitespace-pre-wrap">{error.message}</pre>
          </li>
        ))}
      </ul>
    </Alert>
  )
}
